import { AppRoutes as SharedAppRoutes } from '@cfra-nextgen-frontend/shared/src/routes/AppRoutes';
import { RouteType } from '@cfra-nextgen-frontend/shared/src/routes/types';
import { setUpAwsAmplifyRememberMeListener } from '@cfra-nextgen-frontend/shared/src/routes/utils';
import { ApplicationType } from '@cfra-nextgen-frontend/shared/src/utils/enums';
import { Login } from 'features/auth/components/Login';
import { VerifyToken } from 'features/auth/components/VerifyToken';
import { HomeRoutes } from 'features/home';
import { SnackbarProvider } from 'notistack';
import { useEffect, useRef } from 'react';
import { AuthenticatedRoutesWrapper } from 'routes/AuthenticatedRoutesWrapper';
import { sendSingleInfiniteRequest } from 'utils/api';
import { PageNames, PageNamesToRoutePaths } from 'utils/enum';

const routes: Array<RouteType> = [{ path: '*', element: <HomeRoutes /> }];

const unauthenticatedRoutes: {
    path: string;
    element: JSX.Element;
}[] = [{ path: `${PageNamesToRoutePaths[PageNames.AuthVerify]}`, element: <VerifyToken /> }];

export function AppRoutes() {
    const rememberMe = useRef<boolean>();

    useEffect(() => {
        setUpAwsAmplifyRememberMeListener(rememberMe);
    }, []);

    return (
        <SharedAppRoutes
            loginElement={
                <SnackbarProvider classes={{ containerRoot: 'cfra-snackbar-root' }}>
                    <Login rememberMe={rememberMe} />
                </SnackbarProvider>
            }
            unauthenticatedRoutes={unauthenticatedRoutes}
            authenticatedRoutesJsxGetterProps={{
                authenticatedRoutesWrapperJsx: <AuthenticatedRoutesWrapper />,
                projectSpecificResources: { sendSingleInfiniteRequest },
                routes,
            }}
            applicationType={ApplicationType.AccessibilityPortal}
        />
    );
}
